
import { clinicas } from '../../../mocks/clinicas';

export default function MejoresClinicas() {
  const clinicaE2 = clinicas.find((c) => c.nombre === 'E2 Dental Clinic');
  const otrasClinicas = clinicas.filter((c) => c.nombre !== 'E2 Dental Clinic');

  return (
    <section id="clinicas" className="py-24 bg-gradient-to-b from-white to-ice-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-petrol-700 mb-4">Clínicas Asociadas de Excelencia</h2>
          <p className="text-xl text-petrol-500 max-w-3xl mx-auto">
            Red de clínicas certificadas con los más altos estándares de calidad y tecnología.
          </p>
        </div>

        {clinicaE2 && (
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <span className="bg-olive-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">TOP 3</span>
              <h3 className="text-2xl font-bold text-petrol-700">Clínica Destacada</h3>
            </div>
            <div className="bg-white rounded-3xl overflow-hidden shadow-xl border border-olive-500/20 hover:shadow-2xl transition-all duration-300">
              <div className="grid md:grid-cols-2">
                <div className="relative h-80 md:h-auto min-h-[320px]">
                  <img
                    src={clinicaE2.imagen}
                    alt={clinicaE2.nombre}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/10"></div>
                  <div className="absolute top-4 left-4">
                    <span className="bg-olive-500 text-white rounded-full px-4 py-2 text-sm font-semibold flex items-center gap-2 whitespace-nowrap">
                      <i className="ri-map-pin-line"></i>
                      {clinicaE2.ubicacion}
                    </span>
                  </div>
                </div>
                <div className="p-8 md:p-10 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-3">
                    <h3 className="text-3xl font-bold text-petrol-700">{clinicaE2.nombre}</h3>
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-olive-400 text-sm"></i>
                      ))}
                      <span className="text-sm font-semibold text-petrol-600 ml-1">{clinicaE2.rating}</span>
                    </div>
                  </div>
                  <p className="text-petrol-500 mb-6 leading-relaxed">
                    Excelencia en odontología estética y funcional. Tecnología de vanguardia al servicio de tu bienestar, con más de 15 años liderando la odontología en Mallorca.
                  </p>
                  <p className="text-olive-500 font-semibold text-sm mb-6">{clinicaE2.especialidades}</p>

                  <div className="grid grid-cols-3 gap-4 mb-6">
                    <div className="text-center bg-ice-100 rounded-xl py-4 px-2">
                      <div className="text-2xl font-bold text-petrol-700">{(clinicaE2 as any).experiencia}</div>
                      <div className="text-xs text-petrol-400 mt-1">Experiencia</div>
                    </div>
                    <div className="text-center bg-ice-100 rounded-xl py-4 px-2">
                      <div className="text-2xl font-bold text-petrol-700">{(clinicaE2 as any).pacientes}</div>
                      <div className="text-xs text-petrol-400 mt-1">Pacientes</div>
                    </div>
                    <div className="text-center bg-ice-100 rounded-xl py-4 px-2">
                      <div className="text-2xl font-bold text-petrol-700">{(clinicaE2 as any).satisfaccion}</div>
                      <div className="text-xs text-petrol-400 mt-1">Satisfacción</div>
                    </div>
                  </div>

                  <div className="flex flex-wrap items-center gap-4 text-sm text-petrol-500 mb-6">
                    <span className="flex items-center gap-2">
                      <i className="ri-phone-line text-olive-500"></i>
                      {(clinicaE2 as any).telefono}
                    </span>
                    <span className="flex items-center gap-2">
                      <i className="ri-map-pin-2-line text-olive-500"></i>
                      {(clinicaE2 as any).direccion}
                    </span>
                  </div>

                  <div className="flex gap-3">
                    <a href={(clinicaE2 as any).web} target="_blank" rel="noopener noreferrer nofollow" className="bg-olive-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-olive-600 transition-colors whitespace-nowrap cursor-pointer text-sm">
                      Visitar Web
                    </a>
                    <a href="tel:+34871906242" className="border-2 border-olive-500 text-olive-500 px-6 py-3 rounded-full font-semibold hover:bg-olive-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer text-sm">
                      Llamar Ahora
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {otrasClinicas.map((clinica, index) => (
            <div 
              key={index}
              className="group relative aspect-square rounded-3xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="absolute inset-0">
                <img 
                  src={clinica.imagen}
                  alt={clinica.nombre}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-petrol-700/80 via-petrol-700/20 to-transparent"></div>
              
              <div className="absolute top-4 left-4">
                <span className="bg-white rounded-full px-4 py-2 text-sm font-semibold flex items-center space-x-2 whitespace-nowrap">
                  <i className="ri-map-pin-line text-olive-500"></i>
                  <span>{clinica.ubicacion}</span>
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-xl font-bold mb-2">{clinica.nombre}</h3>
                <div className="flex items-center space-x-2 mb-2">
                  <div className="flex items-center space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <i 
                        key={i}
                        className="ri-star-fill text-olive-400 text-sm"
                      ></i>
                    ))}
                  </div>
                  <span className="text-sm font-semibold">{clinica.rating}</span>
                </div>
                <p className="text-sm text-gray-200">{clinica.especialidades}</p>
              </div>

              <div className="absolute inset-0 bg-petrol-700/95 flex flex-col items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <a 
                  href={(clinica as any).web} 
                  target="_blank" 
                  rel="noopener noreferrer nofollow"
                  className="bg-white text-petrol-700 px-8 py-3 rounded-full font-semibold hover:bg-olive-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Visitar Web
                </a>
                <span className="text-white text-sm flex items-center gap-2">
                  <i className="ri-external-link-line"></i>
                  {(clinica as any).web?.replace('https://', '')}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
